<nexus-grid [data]="sms_messages_model" [sort]="[{ 'field': 'created_date', 'dir': 'desc' }]">
    <kendo-grid-column field="delivered_date" title="Date Delivered" format="G" filter="date"></kendo-grid-column>
    <kendo-grid-column field="message_status" title="Message Status"></kendo-grid-column>
    <kendo-grid-column field="subject" title="Subject"></kendo-grid-column>
    <kendo-grid-column field="number_to" title="SMS Number To">
    </kendo-grid-column>
  </nexus-grid>
  
